import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Modal, Typography, Upload } from "antd";
import { RcFile } from "antd/es/upload/interface";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { fetchChildHeaderDropdownDataByName } from "../FetchData";
import { useSubCategoriesDocumentDetails } from "./GrandChildPas.hooks";

const AddEditslider = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const [uploadModal, setUploadModal] = useState<{
    visible: boolean;
    fieldName?: string;
    file?: RcFile;
    uploading?: boolean;
    setValue?: (name: string, value: string) => void;
  }>({
    visible: false,
    fieldName: undefined,
    file: undefined,
    uploading: false,
  });

  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  // useEffect(() => {
  // fetchHeaderDropdownDataByStringId
  // }, []);

  // Normalize child_heading_id so Select displays the label instead of raw id
  // const [normalizedChildHeadingId, setNormalizedChildHeadingId] = useState<any>(null);
  // useEffect(() => {
  //   let mounted = true;
  //   const normalize = async () => {
  //     try {
  //       const options = await fetchChildHeaderDropdownDataByName();
  //       const rawVal = editSubCategoriesById?.payload?.child_heading_id ?? editSubCategories?.child_heading_id;

  //       // find field definition to determine if it's multiSelect
  //       const fieldDef = fields.grandchildheader?.find((f: any) => f.name === "child_heading_id");
  //       const isMulti = fieldDef?.formType === "multiSelect";

  //       if (rawVal !== undefined && rawVal !== null && rawVal !== "") {
  //         // normalize rawVal into array if multi
  //         const rawArray = isMulti
  //           ? Array.isArray(rawVal)
  //             ? rawVal
  //             : typeof rawVal === "string"
  //             ? rawVal.split(",").map((v) => v.trim()).filter(Boolean)
  //             : [rawVal]
  //           : [rawVal];

  //         const matchedValues: any[] = [];
  //         for (const rv of rawArray) {
  //           const matched = options.find((opt: any) => String(opt.value) === String(rv) || String(opt.label) === String(rv));
  //           if (matched) matchedValues.push(matched.value);
  //           else matchedValues.push(rv);
  //         }

  //         if (mounted) {
  //           setNormalizedChildHeadingId(isMulti ? matchedValues : matchedValues[0]);
  //         }
  //       } else {
  //         if (mounted) setNormalizedChildHeadingId(rawVal ?? "");
  //       }
  //     } catch (err) {
  //       if (mounted) setNormalizedChildHeadingId(editSubCategoriesById?.payload?.child_heading_id ?? editSubCategories?.child_heading_id ?? "");
  //     }
  //   };
  //   normalize();
  //   return () => { mounted = false; };
  // }, [editSubCategories, editSubCategoriesById]);

  const [normalizedChildHeadingId, setNormalizedChildHeadingId] = useState<any>(null);

  useEffect(() => {
    let mounted = true;

    const normalize = async () => {
      try {
        const options = await fetchChildHeaderDropdownDataByName();
        const rawVal = editSubCategoriesById?.payload?.child_heading_id ?? editSubCategories?.child_heading_id;

        // Get field type
        const fieldDef = fields.grandchildheader?.find((f: any) => f.name === "child_heading_id");
        const isMulti = fieldDef?.formType === "multiSelect";

        // ❗ If no value → show blank
        if (!rawVal || rawVal === "" || rawVal === null) {
          if (mounted) setNormalizedChildHeadingId(null);
          return;
        }

        // Normalize into array (for multi-select)
        const rawArray = isMulti
          ? Array.isArray(rawVal)
            ? rawVal
            : typeof rawVal === "string"
              ? rawVal
                  .split(",")
                  .map((v) => v.trim())
                  .filter(Boolean)
              : [rawVal]
          : [rawVal];

        const matchedValues: any[] = [];

        for (const rv of rawArray) {
          const matched = options.find(
            (opt: any) => String(opt.value) === String(rv) || String(opt.label) === String(rv)
          );

          // If label exists → use correct value
          // If label missing → force blank
          if (matched) matchedValues.push(matched.value);
          else matchedValues.push("");
        }

        if (mounted) setNormalizedChildHeadingId(isMulti ? matchedValues : matchedValues[0]);
      } catch (err) {
        if (mounted) {
          setNormalizedChildHeadingId(
            editSubCategoriesById?.payload?.child_heading_id ?? editSubCategories?.child_heading_id ?? null
          );
        }
      }
    };

    normalize();
    return () => {
      mounted = false;
    };
  }, [editSubCategories, editSubCategoriesById]);

  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      name: editSubCategoriesById?.payload?.name || editSubCategories?.name || "",
      grand_child_name_ms:
        editSubCategoriesById?.payload?.grand_child_name_ms || editSubCategories?.grand_child_name_ms || "",
      grand_child_name_zh:
        editSubCategoriesById?.payload?.grand_child_name_zh || editSubCategories?.grand_child_name_zh || "",
      image_url: editSubCategoriesById?.payload?.image_url
        ? [
            {
              uid: "-1",
              name: "grandchild_banner.jpg",
              status: "done",
              url: editSubCategoriesById?.payload?.image_url,
            },
          ]
        : editSubCategories?.image_url
          ? [
              {
                uid: "-1",
                name: "grandchild_banner.jpg",
                status: "done",
                url: editSubCategories?.image_url,
              },
            ]
          : "",
      airports_en: editSubCategoriesById?.payload?.airports_en || editSubCategories?.airports_en || "",
      airports_ms: editSubCategoriesById?.payload?.airports_ms || editSubCategories?.airports_ms || "",
      airports_zh: editSubCategoriesById?.payload?.airports_zh || editSubCategories?.airports_zh || "",
      grand_child_key_en:
        editSubCategoriesById?.payload?.grand_child_key_en || editSubCategories?.grand_child_key_en || "",
      grand_child_key_ms:
        editSubCategoriesById?.payload?.grand_child_key_ms || editSubCategories?.grand_child_key_ms || "",
      grand_child_key_zh:
        editSubCategoriesById?.payload?.grand_child_key_zh || editSubCategories?.grand_child_key_zh || "",
      grand_redirect_url_en:
        editSubCategoriesById?.payload?.grand_redirect_url_en || editSubCategories?.grand_redirect_url_en || "",
      grand_redirect_url_ms:
        editSubCategoriesById?.payload?.grand_redirect_url_ms || editSubCategories?.grand_redirect_url_ms || "",
      grand_redirect_url_zh:
        editSubCategoriesById?.payload?.grand_redirect_url_zh || editSubCategories?.grand_redirect_url_zh || "",
      child_heading_id:
        normalizedChildHeadingId !== null
          ? normalizedChildHeadingId
          : editSubCategoriesById?.payload?.child_heading_id || editSubCategories?.child_heading_id || "",
      published: editSubCategoriesById?.payload?.published ?? editSubCategories?.published ?? false,
    },
    fields: fields.grandchildheader?.map((field: any) => {
      if (field.uploadTrigger) {
        return {
          ...field,
          openUpload: (fieldName: string, setValue: (name: string, value: string) => void) => {
            setUploadModal({ visible: true, fieldName, setValue, file: undefined, uploading: false });
          },
          usedFileType: ".pdf",
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["image_url"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Passenger Navigation",
      subModule: "passengerHeader_grandchildheader",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
        // field_sub_categories_status: true,
        // field_sub_created_at: "2023-11-21T10:01:09",
        // field_sub_updated_at: "2025-11-29T10:01:09"
      },
      status: status,
    };

    // console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Grand Child Header`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${passengerHost}/api/get-grand-child-menu-items-taxonomy-data-list/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/create-grand-child-menu-items-taxonomy-data-list`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Header"
      />
      {/* ------------------- UPLOAD POPUP ------------------- */}
      <Modal
        title="Redirect URL Guide"
        open={uploadModal.visible}
        footer={null}
        onCancel={() => setUploadModal({ ...uploadModal, visible: false, file: undefined })}
        width={520}
      >
        <Typography.Paragraph style={{ marginBottom: 12 }}>
          <ol style={{ margin: 0, paddingLeft: 20 }}>
            <li>
              Use <code>/example</code> for pages within this application.
            </li>
            <li>
              Use a full link for external websites (example: <code>https://example.com</code>).
            </li>
            <li>
              Want to use a file? Click <strong>Upload</strong> and paste the link.
            </li>
          </ol>
        </Typography.Paragraph>

        <Upload.Dragger
          accept="*"
          multiple={false}
          showUploadList={false}
          beforeUpload={(file) => {
            setUploadModal((s) => ({ ...s, file }));
            return false;
          }}
        >
          {uploadModal.file ? (
            <p className="ant-upload-text">{uploadModal.file.name}</p>
          ) : (
            <>
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file here</p>
            </>
          )}
        </Upload.Dragger>

        <div style={{ marginTop: 16, textAlign: "right" }}>
          <Button
            type="primary"
            disabled={!uploadModal.file || uploadModal.uploading}
            onClick={async () => {
              if (!uploadModal.file || !uploadModal.fieldName || !uploadModal.setValue) return;

              setUploadModal((s) => ({ ...s, uploading: true }));

              const formData = new FormData();
              formData.append("upload-file", uploadModal.file);
              formData.append("application", "PASSENGER");

              try {
                const res: any = await post("management/upload-file", formData);
                const url = res?.response?.data;
                if (url) {
                  uploadModal.setValue(uploadModal.fieldName, url);
                  openToast({ content: `File uploaded: ${url}`, type: "success" });
                }
              } catch (e) {
                openToast({ content: "Upload failed", type: "error" });
              } finally {
                setUploadModal({ visible: false, fieldName: undefined, file: undefined, uploading: false });
              }
            }}
          >
            {uploadModal.uploading ? (
              <>
                <LoadingOutlined /> Uploading…
              </>
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </Modal>
    </ContentWrapper>
  );
};

export default AddEditslider;
